export default function SixCardSlider() {
  const sixCard = $('.sixCard__slider');
  if (sixCard.length > 0) {
    sixCard.each(function (num, elem) {
      elem = $(elem);
      elem.slick({
        dots: true,
        infinite: false,
        autoplay: false,
        speed: 0,
        touchMove: true,
        arrows: true,
        prevArrow: $('.sixCard__left')[num],
        nextArrow: $('.sixCard__right')[num],
        cssEase: 'ease',
        accessibility: true,
        cssEase: 'ease-in-out',
      });
      elem.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        elem = $(this);
        let slickDots = elem.find('.slick-dots');
        let left = elem.siblings('.sixCard__left');
        let right = elem.siblings('.sixCard__right');
        elem.slick('setPosition');
        let textHeight = sixCard
          .find('.slick-slide[data-slick-index=' + currentSlide + ']')
          .find('.sixCard__content')
          .height();
        let slideHeight = sixCard
          .find('.slick-slide[data-slick-index=' + currentSlide + ']')
          .height();

        textHeight += 30;
        let helperHeight = slideHeight - textHeight;
        let startArrows = helperHeight / 2 - 19;
        let dotsHeight = helperHeight - 45;

        slickDots.css('top', dotsHeight + 'px');
        left.css('top', startArrows + 'px');
        right.css('top', startArrows + 'px');
      });
    });

    $(window).on('load resize', function () {
      sixCard.each(function (num, elem) {
        elem = $(elem);
        elem.slick('setPosition');
        let textHeight = sixCard
          .find('.slick-slide[data-slick-index=0]')
          .find('.sixCard__content')
          .height();
        let slideHeight = sixCard
          .find('.slick-slide[data-slick-index=0]')
          .height();

        textHeight += 30;
        let helperHeight = slideHeight - textHeight;
        let startArrows = helperHeight / 2 - 19;
        let dotsHeight = helperHeight - 45;
        let slickDots = $('.sixCard__slider .slick-dots');
        slickDots.css('top', dotsHeight + 'px');
        $('.sixCard__left')[num].style.top = startArrows + 'px';
        $('.sixCard__right')[num].style.top = startArrows + 'px';
      });
    });
  }
}
